// Регистрация ждёт подтверждения почты: секрет регистрации хранится на устройстве, и игра сама входит,
// когда почту подтвердят — даже если ссылку открыли в другом браузере, а приложение перезапустилось.
const KEY = 'sk_verify_poll';
const TTL = 2 * 86_400_000;

export function savePendingVerify(pollToken: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ t: pollToken, at: Date.now() }));
  } catch {
    // нет хранилища — останется вход с паролем
  }
}

export function pendingVerifyToken(): string | null {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? 'null') as { t: string; at: number } | null;
    if (v && Date.now() - v.at < TTL) return v.t;
    localStorage.removeItem(KEY);
  } catch {
    // повреждённая запись
  }
  return null;
}

export function clearPendingVerify(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // не важно
  }
}
